import styled from "styled-components";

export const Container = styled.div`
	grid-area: "MC";
	width: calc(100vw - 250px - 42px);
	height: calc(100vh - 20px);
	margin: 0 auto;

	h1 {
		font-size: 34px;
		font-weight: 800;

		margin-bottom: 20px;
	}

	main {
		display: flex;
		gap: 40px;

		h2 {
			border-bottom: 2px solid gray;
			padding: 5px 0;
		}

		.wrapper {
			width: max-content;
			height: 700px;
			border-radius: 10px;
			border: 3px dashed var(--very_light-green);
			padding: 10px;
		}

		.noticeViewer,
		.activeUser {
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			ul {
				margin-top: 15px;
				display: flex;
				flex-direction: column;
				display: flex;
				flex-direction: column;
				gap: 15px;
			}

			a.more {
				align-self: flex-end;
				color: #3f3f3f;
				font-weight: 500;
				font-style: italic;
				padding: 5px 15px;
			}
			a.more:hover {
				color: var(--dark-green);
				border-bottom: 2px solid var(--dark-green);
			}
		}
	}
`;
